<template>
	<v-container fluid class="mb-4">
		<v-toolbar text dark color="secondary" class="my-4">
			<v-toolbar-title>Resultados escolares</v-toolbar-title>
		</v-toolbar>

		<div class="d-flex justify-center d-md-none">
			<v-alert
				border="right"
				colored-border dense
				type="warning"
				elevation="2">
				Não é possível apresentar a grelha de notas neste ecrã.<br/> Experimente rodar o dispositivo ou utilizar um ecrã maior.
			</v-alert>
		</div>

		<div class="d-none justify-space-around d-md-flex">
			<v-form ref="form" v-model="IsFormValid">
				<v-container v-if="NotasAluno.length > 0">
					<v-row>
						<v-col cols="6">
							<span class="subtitle-2">Disciplina / domínio em avaliação</span>

							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text icon color="primary" v-on="on" @click="toggleMostrarAreasAvaliacao" v-show="!MostrarAreasAvaliacao">
										<v-icon>expand_more</v-icon>
									</v-btn>
								</template>
								<span>Mostrar áreas de avaliação</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn text icon color="primary" v-on="on" @click="toggleMostrarAreasAvaliacao" v-show="MostrarAreasAvaliacao">
										<v-icon>expand_less</v-icon>
									</v-btn>
								</template>
								<span>Esconder áreas de avaliação</span>
							</v-tooltip>
						</v-col>
						<v-col cols="2"><span class="subtitle-2">1.º Período</span></v-col>
						<v-col cols="2"><span class="subtitle-2">2.º Período</span></v-col>
						<v-col cols="2"><span class="subtitle-2">3.º Período</span></v-col>
					</v-row>

					<v-row v-for="avaliacao in NotasAluno" :key="avaliacao.id" v-show="avaliacao.componenteInfo.type === 'D' || MostrarAreasAvaliacao">
						<v-col cols="6">
							<v-select
								v-model="avaliacao.componente"
								:items="TiposComponentesAvaliacao"
								:class="{ 'disciplina': avaliacao.componenteInfo.type === 'D', 'area_avaliacao': avaliacao.componenteInfo.type === 'A' }"
								solo
								readonly
								append-icon="false">
							</v-select>
						</v-col>
						<v-col cols="2">
							<v-select
								v-model="avaliacao.primeiro_periodo"
								:items="TiposNota"
								solo clearable>
							</v-select>
						</v-col>
						<v-col cols="2">
							<v-select
								v-model="avaliacao.segundo_periodo"
								:items="TiposNota"
								solo clearable>
							</v-select>
						</v-col>
						<v-col cols="2">
							<v-select
								v-model="avaliacao.terceiro_periodo"
								:items="TiposNota"
								solo clearable>
							</v-select>
						</v-col>
					</v-row>
				</v-container>

				<v-container fluid>
					<v-row>
						<v-spacer></v-spacer>
						<v-col cols="12" md="6" lg="4">
							<v-select
								v-model="ResultadoFinalAluno.transitou"
								:items="ResultadosFinais"
								label="O aluno transitou?">
							</v-select>
						</v-col>
					</v-row>
				</v-container>

				<div class="my-8">
					<v-layout d-flex justify-end>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-btn text color="primary" v-on="on" :disabled="!IsFormValid" @click="save">
									<v-icon left>save</v-icon>
									Gravar
								</v-btn>
							</template>
							<span>Gravar resultados escolares</span>
						</v-tooltip>
					</v-layout>

					<p class="text-end red--text" v-show="!IsFormValid">Existem erros de validação.</p>
				</div>
			</v-form>
		</div>

		<v-divider></v-divider>

        <v-btn color="primary" text class="my-8" @click="goBack()">
            <v-icon left>arrow_back</v-icon>
            Voltar
        </v-btn>

		<Loading :isLoading="isLoading" />

		<v-snackbar v-model="Snackbar.show" bottom right vertical :timeout="5000">
			{{ Snackbar.message }}
			<v-btn text @click="Snackbar.show = false">Fechar</v-btn>
		</v-snackbar>

		<ErrorDialog :show-dialog="this.errorMessage.show" :error-message="this.errorMessage"></ErrorDialog>
	</v-container>
</template>

<script>
    import Vue from 'vue'
	import StaticData from '@/data/static-data.js';
	Vue.use(StaticData);
	import HelperService from '@/services/helper.js';
	const Helper = new HelperService();

	import Loading from "@/components/Loading";

	import ErrorDialog from '@/components/ErrorDialog';

    export default {
		components: {
			Loading,
			ErrorDialog
		},

        data: () => ({
			isLoading: false,
			errorMessage: {
				show: false
			},
			IsFormValid: true,
			TiposComponentesAvaliacao: [], // to be loaded on created
			TiposNota: StaticData.TiposNota,
			ResultadosFinais: StaticData.ResultadosFinais,
			MostrarAreasAvaliacao: false,
			NotasAluno: [],
			ResultadoFinalAluno: {},
            InputRules: {
                minMaxValue: value => (!value || value >= 0 && value <= 100) || 'O valor deverá estar compreendido entre 0 e 100'
			},
			Snackbar: {
				show: false,
				message: 'Informação registada com sucesso.'
			},
        }),

        created () {
			this.alunoTurmaId = this.$route.params.alunoTurmaId;
			this.loadNotas();
			this.loadResultadoFinal();
        },

        methods: {
			getPeriodoFromFase(fase) {
				switch (fase) {
					case 1:
						return 'primeiro_periodo';
					case 2:
						return 'segundo_periodo';
					case 3:
						return 'terceiro_periodo';
				}
			},
			loadNotas () {
				this.isLoading = true;

				/// Primeiro, carregar lista de componentes de avaliação
				this.$http.get(process.env.VUE_APP_API_ROOT + '/componenteavaliacao').then(function(componentesAvaliacaoData){
                    return componentesAvaliacaoData.json();
                }).then(function(componentesAvaliacaoData) {
					// console.log('componentes de avaliação', componentesAvaliacaoData);

                    componentesAvaliacaoData.forEach (item => {
                        this.TiposComponentesAvaliacao.push({ value: item.id, text: item.nome, type: item.tipo, parent: item.pai });
					});

					/// Depois, carregar notas já gravadas (caso existam)
					this.$http.get(process.env.VUE_APP_API_ROOT + `/aluno-nota?aluno_turma=${this.alunoTurmaId}`).then(function(resultadosEscolaresData){
						return resultadosEscolaresData.json();
					}).then(function(resultadosEscolaresData){
						// console.log("resultados escolares", resultadosEscolaresData);

						let resultadosEscolares = [];
						let alunoTurmaId = this.alunoTurmaId;

						/// Se já tiver notas, gerar grelha já com as notas
						if (resultadosEscolaresData != null && resultadosEscolaresData.length > 0) {
							/// Pegar nas notas por fase e agrupá-las por componente
							let notasPorFaseAgrupadas = Helper.groupBy(resultadosEscolaresData, item => item.componente);
							let notasComponentes = [];
							notasPorFaseAgrupadas.forEach(itemAvaliacao => {
								let itemAvaliacaoPrimeiroPeriodo = Helper.findBy(itemAvaliacao, item => item.fase, 1);
								let itemAvaliacaoSegundoPeriodo = Helper.findBy(itemAvaliacao, item => item.fase, 2);
								let itemAvaliacaoTerceiroPeriodo = Helper.findBy(itemAvaliacao, item => item.fase, 3);

								notasComponentes.push({
									id: itemAvaliacao[0].componente,
									componente: itemAvaliacao[0].componente,
									primeiro_periodo: itemAvaliacaoPrimeiroPeriodo ? itemAvaliacaoPrimeiroPeriodo.nota : null,
									primeiro_periodo_id: itemAvaliacaoPrimeiroPeriodo ? itemAvaliacaoPrimeiroPeriodo.id : null, // auxiliar, para poder mapear na gravação
									segundo_periodo: itemAvaliacaoSegundoPeriodo ? itemAvaliacaoSegundoPeriodo.nota : null,
									segundo_periodo_id: itemAvaliacaoSegundoPeriodo ? itemAvaliacaoSegundoPeriodo.id : null,
									terceiro_periodo: itemAvaliacaoTerceiroPeriodo ? itemAvaliacaoTerceiroPeriodo.nota : null,
									terceiro_periodo_id: itemAvaliacaoTerceiroPeriodo ? itemAvaliacaoTerceiroPeriodo.id : null
								});
							});

							/// Criar objectos relativos a cada componente e adicionar as notas de cada um, caso já existam
							this.TiposComponentesAvaliacao.forEach(componente => {
								let notasComponente = Helper.findBy(notasComponentes, item => item.componente, componente.value);

								resultadosEscolares.push({
									aluno_turma: alunoTurmaId,
									componente: componente.value,
									componenteInfo: componente,
									primeiro_periodo: notasComponente ? notasComponente.primeiro_periodo : null,
									primeiro_periodo_id: notasComponente ? notasComponente.primeiro_periodo_id : null,
									segundo_periodo: notasComponente ? notasComponente.segundo_periodo : null,
									segundo_periodo_id: notasComponente ? notasComponente.segundo_periodo_id : null,
									terceiro_periodo: notasComponente ? notasComponente.terceiro_periodo : null,
									terceiro_periodo_id: notasComponente ? notasComponente.terceiro_periodo_id : null
								});
							});

							/// Atribuir valor ao objecto para geração da grelha
							this.NotasAluno = resultadosEscolares;
						}
						else { /// Caso contrário, gerar grelha vazia
							/// Criar objectos relativos a cada componente, ainda com as notas por preencher
							this.TiposComponentesAvaliacao.forEach(componente => {
								// console.log('componente', componente);
								resultadosEscolares.push({
									aluno_turma: alunoTurmaId,
									componente: componente.value,
									componenteInfo: componente,
								});
							});
							
							/// Atribuir valor ao objecto para geração da grelha
							this.NotasAluno = resultadosEscolares;
						}

						// console.log('this.NotasAluno', this.NotasAluno);
					});

					this.isLoading = false;
				}, response => { // error callback
					this.isLoading = false;
				});
			},
			loadResultadoFinal () {
				this.isLoading = true;

				this.$http.get(process.env.VUE_APP_API_ROOT + `/aluno-resultado-final?aluno_turma=${this.alunoTurmaId}`).then(function(data){
                    return data.json();
                }).then(function(data){
					// console.log("resultado final", data);
					
					if (data && data.length == 1) {
						this.ResultadoFinalAluno = data[0];
					}

					this.isLoading = false;
                }, response => { // error callback
					this.isLoading = false;
				});
			},
			toggleMostrarAreasAvaliacao () {
				this.MostrarAreasAvaliacao = !this.MostrarAreasAvaliacao;
			},
			save () {
				this.saveNotas();
				this.saveResultadoFinal();
			},
			saveNotas () {
				var arrayAvaliacaoFaseAluno = [];
				this.NotasAluno.forEach(item => {
					// console.log('item', item);

					if (item.primeiro_periodo) {
						arrayAvaliacaoFaseAluno.push({
							id: item.primeiro_periodo_id,
							aluno_turma: item.aluno_turma,
							componente: item.componente,
							fase: 1,
							nota: item.primeiro_periodo
						});
					}

					if (item.segundo_periodo) {
						arrayAvaliacaoFaseAluno.push({
							id: item.segundo_periodo_id,
							aluno_turma: item.aluno_turma,
							componente: item.componente,
							fase: 2,
							nota: item.segundo_periodo
						});
					}

					if (item.terceiro_periodo) {
						arrayAvaliacaoFaseAluno.push({
							id: item.terceiro_periodo_id,
							aluno_turma: item.aluno_turma,
							componente: item.componente,
							fase: 3,
							nota: item.terceiro_periodo
						});
					}
				});
				// console.log(arrayAvaliacaoFaseAluno);

				arrayAvaliacaoFaseAluno.forEach(item => {
					if (item.id) {
						this.isLoading = true;

						this.$http.put(process.env.VUE_APP_API_ROOT + `/aluno-nota/${item.id}/`, item).then(function(data){
							// console.log(data);

							this.Snackbar.show = true;

							this.isLoading = false;
						}, response => { // error callback
							console.log(response);

							this.errorMessage.message = "Ocorreu um erro ao gravar os dados.";
							this.errorMessage.show = true;

							this.isLoading = false;
						});
					}
					else {
						this.isLoading = true;

						this.$http.post(process.env.VUE_APP_API_ROOT + '/aluno-nota/', item).then(function(data){
							console.log(data);

							let avaliacaoAluno = Helper.findBy(this.NotasAluno, item => item.componente, item.componente);
							console.log('avaliacaoAluno', avaliacaoAluno);
							// console.log('avaliacaoAluno[fase]', avaliacaoAluno[this.getPeriodoFromFase(item.fase) + '_id']);
							avaliacaoAluno[this.getPeriodoFromFase(item.fase) + '_id'] = data.body.id;
							// console.log('avaliacaoAluno', avaliacaoAluno);
							// console.log('avaliacaoAluno[fase]', avaliacaoAluno[this.getPeriodoFromFase(item.fase) + '_id']);

							this.Snackbar.show = true;

							this.isLoading = false;
						}, response => { // error callback
							console.log(response);

							this.errorMessage.message = "Ocorreu um erro ao ao gravar os dados.";
							this.errorMessage.show = true;

							this.isLoading = false;
						});
					}
				});
			},
			saveResultadoFinal () {
				console.log("ResultadoFinalAluno", this.ResultadoFinalAluno);

				if (this.ResultadoFinalAluno && this.ResultadoFinalAluno.transitou != null) {
					this.isLoading = true;

					if (this.ResultadoFinalAluno.id) {
						this.$http.put(process.env.VUE_APP_API_ROOT + `/aluno-resultado-final/${this.ResultadoFinalAluno.id}/`, this.ResultadoFinalAluno).then(function(data){
							console.log(data);

							this.Snackbar.show = true;

							this.isLoading = false;
						}, response => { // error callback
							console.log(response);

							this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
							this.errorMessage.show = true;

							this.isLoading = false;
						});
					}
					else {
						this.ResultadoFinalAluno.aluno_turma = this.alunoTurmaId;

						this.$http.post(process.env.VUE_APP_API_ROOT + '/aluno-resultado-final/', this.ResultadoFinalAluno).then(function(data){
							console.log(data);

							this.ResultadoFinalAluno = data.body;

							this.Snackbar.show = true;
							// console.log("ResultadoFinalAluno", this.ResultadoFinalAluno);

							this.isLoading = false;
						}, response => { // error callback
							console.log(response);

							this.errorMessage.message = "Ocorreu um erro ao editar ao gravar os dados.";
							this.errorMessage.show = true;

							this.isLoading = false;
						});
					}
				}
			},
			goBack () {
                window.history.length > 1
                    ? this.$router.go(-1)
                    : this.$router.push('/')
            }
        },
    }
</script>


<style lang="scss" scoped>
	.row {
		height: 50px;
	}

	.disciplina {
		font-weight: bold;
	}
	.area_avaliacao {
		padding-left: 40px;
		font-size: 14px;
	}
</style>